import { ApiCore } from '@polyu-dip/api-core'
import { UserResponsePayload } from '../users'

const PATH = '/my-profile'

export function getMyProfile() {
  return ApiCore.primary.get<UserResponsePayload>(PATH)
}
